<div class="paging">
    <button class="prevBtn" (click)="prevPage()"></button>
    <span>{{PageNo}} / {{numAllPages}}</span>
    <button class="nextBtn" (click)="nextPage()"></button>
</div>